/* eslint-disable */
export default {
  mute: '음소거',
  unmute: '음소거 해제',
  hangup: '전화 끊기',
  reject: '거부',
  hold: '대기',
  onHold: '대기 중',
  transfer: '전달',
  more: '더 보기',
  stopRecord: '기록 중지',
  record: '레코드',
  showKeypad: '키패드',
  hideKeypad: '키패드 숨기기',
  unHold: '보류 해제',
  forward: '착신 전환',
  ignore: '무시',
  voicemail: '음성 사서함에 보내기',
  custom: '사용자 지정',
  answerAndEnd: '응답 후 종료',
  answerAndHold: '응답 후 대기',
  answer: '응답',
  completeTransfer: '전달 완료',
  reply: '회신',
  add: '추가',
  mergeCall: '진행 중인 통화와 병합',
  endCallForEveryone: '모든 사람의 통화 종료',
  leaveCall: '통화에서 나가기',
  leaveOrEndCall: '통화에서 나가거나 종료하시겠습니까?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
